import styled from 'styled-components';

export const StatusContainerWithActionBar = styled.div`
  position: relative;
  direction: flex;
  flex-direction: column;
  padding: 1rem 1rem 0;
  min-height: 130px;
`;

export const StatusBottomBar = styled.div`
  height: 52px;
  align-items: center;
`;
